/**
 * Get the parent loop for an item with a given ID.
 *
 * @param {Number} itemID - The ID of the item to check.
 * @param {Object[]} [items=UncannyAutomator._recipe.actions.items] - The items array inside the UncannyAutomator object. Defaults to the top level for the initial call.
 * @param {Object|null} [parentLoop=null] - The current parent loop, if any.
 * @return {Object|undefined} The parent loop object if found, otherwise `undefined`.
 */
const getParentLoop = ( itemID, items = UncannyAutomator._recipe.actions.items, parentLoop = null ) => {
	for ( const item of items ) {
		// Update the current parent loop if the item is of type 'loop'.
		const currentLoop = item.type === 'loop' ? item : parentLoop;

		// If the item ID matches the given ID and there's a current parent loop, return that loop.
		if ( item.id === itemID && currentLoop ) {
			return currentLoop;
		}

		// If the current loop has filters, search within them.
		if ( item.filters && item.filters.some( filter => filter.id === itemID ) ) {
			return currentLoop;
		}

		// If the current item has nested items, recursively search within them.
		if ( item.items ) {
			const foundLoop = getParentLoop( itemID, item.items, currentLoop );
			if ( foundLoop ) {
				return foundLoop;
			}
		}
	}
}

export default getParentLoop;
